module.exports = __webpack_public_path__ + "img/EmergencyIcon.2337ea75.png";